module.exports = __webpack_public_path__ + "img/Proficient.c3713548.svg";